var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPicture7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 22,
    height: 22,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAMAAADzapwJAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAE4UExURQAAAAAAAAAA/wD//wCAgACA/wBVqgCqqgBmmQCZzABttgCOqgCAzABqvwCAvwB3qgB3uwCAuQB2sQB7uQB4twB4vAB1ugB3vgB4uwB2ugB2vQB3uQB5twB8ugB5uQB5vAB5uwB4ugB4ugB6uwB7vAB5uwB6uwB5uQB5ugB7uwB4ugB5ugB5uQB5uwB5ugB4vAB5vAB5uwB4vAB6vQB5ugB7vgB5uwB4uwB4vAB5uwB5vQB5uwB4ugB5uwB6vAB5ugB4vAB5uwB6vAB9wAB5uwB6uwB5ugB4uwB7vwB8vwB5ugB5uwB4ugB5uwB5vAB7vwB5uwB6vQB4uwB5uwB5uwB5uwB7vgB6vAB4uwB5uwB5vAB6vAB6vQB7vQB8vwB8wAB8wQB9wAB9wQB9wgB+wwB/wwCAxQCAxu816WwAAABZdFJOUwABAQECAgMDBQUHCQoMDA8PFhodICIlLzE0NklKSkxQUlVZWmZpbW52fIKNj4+Um5yen5+ipKWoqKmxs8HG1dfY2dra3N7f6ers8fHz9Pb29/f4+Pv8/P3+PIAApgAAAAlwSFlzAAAOwwAADsMBx2+oZAAAANpJREFUKFNjELMOtZdhwABWyZEJLiJQDgKERkbGBCpAOQhglxQT7yEJ5SCArGuIlyaUjQxEFaVYoUwkwMYCxAwMTBxAwMTAKSgsxMsIFFa1NLPU5mYQNzK30BeTMHTzdbdR42FgME1PSnMWYJDzT0n11HJKiY2OiU/U42IwiYuMc+RnkPaNiQryi4uJiQQ6OEweSTgyMjbc2ys8OjIy3hhZOCpAXYBPIzg6MsYBWTjejJ2Bgdk2PjLKB1k4VQXkYoO4yMgIZOEkZZCwLlA4Elk4QQkkrDOYhCMjAdg3VBx1IFLtAAAAAElFTkSuQmCC",
    preserveAspectRatio: "none",
    id: "img0"
  }), /*#__PURE__*/React.createElement("pattern", {
    width: 22,
    height: 22,
    patternUnits: "userSpaceOnUse",
    id: "pattern1",
    overflow: "hidden",
    patternTransform: "matrix(0.983905 0 0 0.983904 11.1771 9.99023)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M43.646 21.6459C43.646 33.6006 33.9548 43.2918 22.0001 43.2918 10.0454 43.2918 0.354199 33.6006 0.354199 21.6459 0.354199 9.6912 10.0454 7.26318e-07 22.0001 7.26318e-07 33.9548 7.26318e-07 43.646 9.6912 43.646 21.6459Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1771 9.99023 32.823 9.99023 32.823 31.6361 11.1771 31.6361Z",
    fill: "url(#pattern1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture7);
export default __webpack_public_path__ + "static/media/Picture7.a4c44ec0f48139837cf758b35376e25e.svg";
export { ForwardRef as ReactComponent };